export default __webpack_public_path__ + "static/media/qwiklabs5.7e22c29f.png";